<template>
  <header class="card-header">
    <h4>
      {{ titulo }}&nbsp;
      <small>
        <a @click="abreModal()" style="cursor: pointer;">{{ subtitulo }}</a>
      </small>
    </h4>

    <div class="registros" v-if="this.autenticados.length > 1">
      <span>
        <i class="fa fa-user-circle-o" aria-hidden="true"></i>
      </span>

      <div class="form-group">
        <select
          class="form-control"
          v-model="funcionario"
          @change="trocaUsuario(funcionario)"
        >
          <option
            v-for="autenticado in autenticados"
            :key="autenticado.id"
            :value="autenticado"
          >
            {{ 'Registro ' + autenticado.registroFormatado }}
          </option>
        </select>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'CardHeader',

  data() {
    return {
      autenticados: this.$store.state.usuarioLogado.funcionarios,
      funcionario: this.$store.state.funcionario,
    };
  },

  props: {
    titulo: {
      required: true,
      type: String,
    },
    subtitulo: {
      required: false,
      type: String,
      default: '',
    },
  },

  computed: {
    usuarioAtual() {
      return this.$store.state.funcionario;
    },
  },

  watch: {
    usuarioAtual(novo, anterior) {
      this.funcionario = novo;
    },
  },

  methods: {
    abreModal() {
      this.$emit('abreModal');
    },
    trocaUsuario(funcionario) {
      this.$store.commit('setFuncionario', funcionario);
    },
  },
};
</script>

<style scoped>
.card-header {
  display: grid;
  grid-template-columns: auto 220px;
}
.registros {
  display: flex;
  justify-content: flex-end;
  height: 60px;
  color: #00615c;
}
.registros span {
  display: flex;
  align-items: flex-start;
  margin-top: 20px;
  padding: 3px 10px 0 0;
  font-size: 1.8em;
}
.registros .form-group {
  margin-top: 20px;
  margin-bottom: 0;
}
.registros .form-group .form-control {
  padding: 3px 12px;
  height: auto;
}
@media screen and (max-width: 767px) {
  .card-header {
    grid-template-columns: 100%;
  }
  .registros {
    justify-content: flex-start;
    height: 60px;
  }
  .registros span {
    margin-top: 0;
  }
  .registros .form-group {
    margin-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?58905400